import AlgoPrice from 'components/AlgoPrice'
import type { PriceFilterProps } from './PriceFilter'

type ActivePriceFilterProps = Omit<PriceFilterProps, 'type'>

export default function ActivePriceFilters({
  minPrice,
  maxPrice,
  setPriceRange
}: ActivePriceFilterProps) {
  if (minPrice === null && maxPrice === null) {
    return null
  }

  const handleClearFilter = async () => {
    await setPriceRange({ minPrice: null, maxPrice: null })
  }

  const renderLabel = () => {
    if (minPrice === null) {
      return (
        <span>
          Max Price: <AlgoPrice price={maxPrice as number} />
        </span>
      )
    }

    if (maxPrice === null) {
      return (
        <span>
          Min Price: <AlgoPrice price={minPrice} />
        </span>
      )
    }

    return (
      <span>
        Price: <AlgoPrice price={minPrice} /> - <AlgoPrice price={maxPrice} />
      </span>
    )
  }

  return (
    <span className="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white text-gray-900">
      <span>{renderLabel()}</span>
      <button
        type="button"
        className="flex-shrink-0 ml-1 h-4 w-4 p-1 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500"
        onClick={() => handleClearFilter()}
      >
        <span className="sr-only">Remove filter for Price</span>
        <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
          <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    </span>
  )
}
